export class LoginUserRequestModel {
  userName: string = "";
  password: string = "";
  nit: string = "";
  changeSession: boolean = false;
}